import React from "react"
import PropTypes from "prop-types"
import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import withRewardOnChange from "./withRewardOnChange"

const PROPERTY = "urlSlug"

const VALIDATION_MESSAGE_REQUIRED = "This is required"
const VALIDATION_MESSAGE_FORMAT = "Only alphanumeric/ dashes/ ampersand characters allowed. No special characters."
const VALIDATION_MESSAGE_MAX_LENGTH = "This field cannot have more than 100 characters."

export const schema = Validation
  .string(VALIDATION_MESSAGE_REQUIRED)
  .max(100, VALIDATION_MESSAGE_MAX_LENGTH)
  .matches(/^[a-z0-9-&]+$/i,
    VALIDATION_MESSAGE_FORMAT)

const URLSlug = ({reward, onChange, required, label, referenceData, ...props}) => {
  return (
    <Input
      name={PROPERTY}
      value={reward[PROPERTY]}
      onChange={(value) => onChange(reward, PROPERTY, value)}
      label={`${label}${required ? "*" : ""}`}
      {...props}
      id={id(PROPERTY, props)} />
  )
}

URLSlug.propTypes = {
  reward: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  validation: PropTypes.object
}

URLSlug.defaultProps = {
  required: true,
  placeholder: "unique (words + integers))",
  label: "URL Slug:",
  validation: schema,
  id: "urlSlug"
}

export default withRewardOnChange(URLSlug)
